import { Link, useLocation } from '@remix-run/react';
import { Button } from '~/components/ui/button';
import { Download, Globe } from 'lucide-react';

export function MultipleCta({ ...props }) {
    const location = useLocation();
    const path = location.pathname.replaceAll('/', '_');

    return (
        <div className='mt-2 flex flex-col  justify-center items-center gap-4'>
            <Button
                asChild
                className='flex-col items-center text-left h-20  w-full mx-0 inline-flex justify-center px-8 py-3.5 mt-0 font-bold transition-all  border-none font-pj text-lg rounded-xl md:mx-auto md:w-full bg-[linear-gradient(60deg,#f79533,#f37055,#ef4e7b,#a166ab,#5073b8,#1098ad,#07b39b,#6fba82)] bg-[length:300%_300%]  text-white focus:outline-none hover:bg-black hover:bg-gradient-to-r hover:from-black hover:to-black'>
                <a
                    href= 'https://perfectassistant.ai/downloads/AiPerfectAssistant.zip'
                    download>
                    <div className='flex items-center'>
                        <Download className='mr-2 h-5 w-5' />
                        <span>Download for Windows</span>
                    </div>
                </a>
            </Button>
            <Button variant='outline' asChild className='text-lg px-6 py-5'>
                <Link to={`/iframe?source=landing${encodeURIComponent(path)}`}>
                    <Globe className='mr-2 h-5 w-5' />
                    Use Web Version (No install)
                </Link>
            </Button>
        </div>
    );
}

function ButtonRainbow({ ...props }) {
    const location = useLocation();
    const path = location.pathname.replaceAll('/', '_');

    return (
        <Link
            className='w-full mx-0 inline-flex items-center justify-center px-8 py-3.5 mt-0 font-bold transition-all  border-none font-pj text-lg rounded-xl md:mx-auto md:w-full bg-[linear-gradient(60deg,#f79533,#f37055,#ef4e7b,#a166ab,#5073b8,#1098ad,#07b39b,#6fba82)] bg-[length:300%_300%]  text-white focus:outline-none hover:bg-black hover:bg-gradient-to-r hover:from-black hover:to-black'
            {...props}
            to={`/iframe?source=landing${encodeURIComponent(path)}`}>
            Start Using AI Assistant&nbsp;&rarr;
        </Link>
    );
}

export default ButtonRainbow;
